// The Web Analytics site token is a public identifier, not an API credential.
// Fill this only with the token issued for fontlab.ge by Cloudflare.
export const analyticsConfig = {
  token: "5438406da50d421298f7dd700382e9e9",
  measurementId: "G-4SJ8ZDR05Y",
  hostnames: ["fontlab.ge", "www.fontlab.ge"],
};

export function enableAnalytics(config = analyticsConfig) {
  if (!config.hostnames.includes(window.location.hostname)) return;
  if (config.measurementId && !document.querySelector('script[data-fontlab-ga]')) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", config.measurementId);
    const googleTag = document.createElement("script");
    googleTag.async = true;
    googleTag.dataset.fontlabGa = config.measurementId;
    googleTag.src = `https://www.googletagmanager.com/gtag/js?id=${config.measurementId}`;
    document.head.appendChild(googleTag);
  }
  if (!config.token) return;
  if (document.querySelector('script[data-cf-beacon]')) return;
  const script = document.createElement("script");
  script.type = "module";
  script.src = "https://static.cloudflareinsights.com/beacon.min.js";
  script.dataset.cfBeacon = JSON.stringify({ token: config.token });
  document.head.appendChild(script);
}
